<template>
  <div class="vertical-align-step-1" lang="tr">
    <h3 class="main_question text-center font-weight-normal">
      {{ $t('Neden iletişim bilgilerimi doğru girmeliyim?') }}
      <a
        id="whyContactInfo"
        data-target="#why-contact-info-modal"
        data-toggle="modal"
        href="#"
        class="btn-outline-mukellef btn-radius mx-2"
      >
        <i class="fa fa-play link-button-icon"></i><span>{{ $t('Videoyu İzleyin') }}</span>
      </a>
    </h3>
    <form id="step1" method="POST" @submit="sendForm">
      <h3 class="main_question"><strong>1/3</strong>{{ $t('Kişisel Bilgileriniz') }}</h3>
      <div class="row">
        <div class="col-md-6">
          <InputField
            v-model="form.id_identifier_number"
            class="identity mb-3"
            v-mask="'###########'"
            name="id_identifier_number"
            v-tippy="form.foreign_citizen ? $t('Yabancı Uyruk No Tooltip') : $t('T.C. Kimlik No Tooltip')"
            :placeholder="form.foreign_citizen ? $t('Yabancı Uyruk No') : $t('T.C. Kimlik No')"
            v-validate="'required|min:11|max:11'"
            :disabled="isNewUser && formCopy.id_identifier_number"
            :error="errors.first('id_identifier_number')"
            errorBox="id_identifier_number"
            :validateFields="fields['id_identifier_number']"
          />
          <div class="mb-3 d-inline-block">
            <label class="container_check version_2">
              {{ $t('Yabancı vatandaşım') }}
              <input v-model="form.foreign_citizen" name="foreign-citizen" type="checkbox" value="true" />
              <span class="checkmark"></span>
            </label>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <vue-tel-input
              id="phone-mask"
              @validate="mobilePhoneValidate"
              v-model="form.mobile"
              class="form-control"
              :input-options="{ placeholder: $t('Cep Telefonu Numarası') }"
            ></vue-tel-input>
            <error-box field="mobile" />
          </div>
        </div>
      </div>

      <h3 class="main_question">{{ $t('Doğum Bilgileriniz') }}</h3>
      <div class="row mb-3">
        <div class="col-12">
          <date-picker
            v-model="form.birthday"
            name="birthday"
            @blur="birthdateMessage"
            v-tippy="$t('Doğum Tarihi Tooltip')"
            class="w-100 mb-1"
            :class="errors.first('birthday') ? 'is-invalid' : 'is-valid'"
            input-class="date-picker input-field"
            :popup-style="{ top: '100%', left: 0 }"
            :append-to-body="false"
            format="DD/MM/YYYY"
            :disabled="isNewUser && Boolean(formCopy.birthday)"
            valueType="format"
            :lang="$i18n.locale"
            v-validate="'required|date_format:dd/MM/yyyy|ageLimit:18'"
            :error="errors.first('birthday')"
            :placeholder="$t('Doğum Tarihi (gg/aa/yyyy)')"
          ></date-picker>
          <span v-show="errors.first('birthday')" class="show-invalid invalid-feedback">{{
            errors.first('birthday')
          }}</span>
          <error-box field="birthday" />
        </div>
      </div>
      <h3 class="main_question">{{ $t('Adres Bilgileriniz') }}</h3>
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <div class="clearfix">
              <v-select
                v-model="addressCity"
                :filterBy="filterSelect"
                :options="cities"
                :searchable="false"
                class="wide input-field"
                :class="{ 'is-invalid': errors.first('address-city') }"
                label="name"
                name="address-city"
                v-validate="'required'"
                :placeholder="$t('Adres il')"
                :disabled="isNewUser && Boolean(formCopy.address.city_readable)"
                value="id"
                @input="setAddressCity"
              >
                <span slot="no-options">{{ $t('Üzgünüz, belirtmiş olduğunuz il bulunamadı') }}</span>
              </v-select>
              <span v-show="errors.first('address-city')" class="show-invalid invalid-feedback">{{
                errors.first('address-city')
              }}</span>
              <error-box field="address.city_id" />
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <div class="clearfix">
              <v-select
                v-model="addressDistrict"
                :filterBy="filterSelect"
                :options="addressDistricts"
                :searchable="false"
                class="wide input-field"
                :class="{ 'is-invalid': errors.first('address-district') }"
                v-validate="'required'"
                label="name"
                :disabled="isNewUser && Boolean(formCopy.address.district_readable)"
                name="address-district"
                :placeholder="$t('Adres ilçe')"
                value="id"
                @input="setAddressDistrict"
              >
                <span slot="no-options">{{ $t('Üzgünüz, belirtmiş olduğunuz ilçe bulunamadı') }}</span>
              </v-select>
              <span v-show="errors.first('address-district')" class="show-invalid invalid-feedback">{{
                errors.first('address-district')
              }}</span>
              <error-box field="address.district_id" />
            </div>
          </div>
        </div>
      </div>
      <div class="row mb-4">
        <div class="col-12">
          <textarea
            class="form-control input-field"
            v-validate="'required'"
            name="fullAdress"
            :class="{ 'is-invalid': errors.first('fullAdress') }"
            v-model="form.address.fullAddress"
            :placeholder="this.$t('Adresinizi Giriniz')"
            :disabled="isNewUser && Boolean(formCopy.address.fullAddress)"
            rows="4"
          ></textarea>
          <span v-show="errors.first('fullAdress')" class="show-invalid invalid-feedback">{{
            errors.first('fullAdress')
          }}</span>
        </div>
      </div>
    </form>
    <BirthdateInformationModal />
    <a v-show="false" id="birthdateMessage" data-target="#birthdate-information-modal" data-toggle="modal" href="#" />
    <MobileVerify
      :mobile="form.mobile"
      ref="mobileVerifyComponent"
      :limit-message="limitMessage"
      @mobile-verified="emailVerified()"
    />
  </div>
</template>
<script>
import BirthdateInformationModal from '../../../modals/BirthdateInformationModal';
import InputField from './../../../InputField.vue';

export default {
  computed: {
    addressCity: {
      get: function () {
        if (this.form.address.city_id) {
          return {
            id: this.form.address.city_id,
            name: this.form.address.city_readable,
          };
        }

        return null;
      },
      set: function () {},
    },
    addressDistrict: {
      get: function () {
        if (this.form.address.district_id) {
          return {
            id: this.form.address.district_id,
            name: this.form.address.district_readable,
          };
        }

        return null;
      },
      set: function () {},
    },
  },
  data() {
    return {
      birthdayToggle: false,
      cities: [],
      birthDistricts: [],
      addressDistricts: [],
      form: {
        address: {},
      },
      formCopy: {
        address: {},
      },
      mobileNumberIsValid: false,
      callback: null,
      limitMessage: null,
    };
  },
  props: {
    isNewUser: {
      type: Boolean,
    },
  },
  created() {
    this.createTestFunctions();
    this.startWaiting();
    this.$store.dispatch('getSelf').then(() => {
      const form = JSON.parse(JSON.stringify(this.$store.state.selfMeData));
      this.form = form;
      this.formCopy = JSON.parse(JSON.stringify(this.$store.state.selfMeData));
      this.endWaiting();
      if (this.form.address.city_id) {
        this.getDistricts(this.form.address.city_id, (districts) => {
          this.addressDistricts = districts;
        });
      }

      if (this.form.mobile == null) {
        this.form.mobile = '';
      }

      this.endWaiting();
    });
    $axios.get('city').then((s) => {
      this.cities = s.data.data;
    });
  },
  methods: {
    emailVerified() {
      this.startWaiting();
      this.callback(true);
    },
    mobilePhoneValidate(event) {
      this.mobileNumberIsValid = event.valid;
    },
    birthdateMessage(e) {
      if (this.birthdayToggle === false) {
        window.document.getElementById('birthdateMessage').click();
        this.birthdayToggle = true;
      }
    },
    setAddressCity(city) {
      if (!city) {
        this.form.address.city_id = null;
        this.form.address.city_readable = null;
        return;
      }

      this.form.address.city_id = city.id;
      this.form.address.city_readable = city.name;
      if (this.addressDistricts.length) {
        this.form.address.district_id = null;
        this.form.address.district_readable = null;
      }
      this.getDistricts(city.id, (districts) => {
        this.addressDistricts = districts;
      });
    },
    setAddressDistrict(district) {
      if (!district) {
        this.form.address.district_id = null;
        this.form.address.district_readable = null;

        return;
      }

      this.form.address.district_id = district.id;
      this.form.address.district_readable = district.name;
    },
    sendForm(callback) {
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (!this.mobileNumberIsValid) {
            window.Vue.$toasted.error(this.$t('AlertMessages.Lütfen geçerli bir telefon numarası girin'));
            return;
          }
          this.startWaiting();
          const form = JSON.parse(JSON.stringify(this.form));
          form.mobile = '+' + form.mobile.replace(/[^0-9.]/g, '');
          const birthdayGroup = form.birthday.split('/');
          if (birthdayGroup.length === 3) {
            // Change Birthday Format DD/MM/YYYYY
            form.birthday = birthdayGroup[2] + '/' + birthdayGroup[1] + '/' + birthdayGroup[0];
          }
          this.limitMessage = null;

          form.address.city_id = this.addressCity.id;
          form.address.district_id = this.addressDistrict.id;
          $axios
            .put('register/profile', form)
            .then((s) => {
              this.$toasted.show(this.$t('AlertMessages.Bilgileriniz kaydedildi'));
              this.callback = callback;
              if (form.mobile.startsWith('+90') && !s.data.data.is_mobile_verified) {
                this.endWaiting();
                const element = this.$refs.mobileVerifyComponent.$el;
                this.$refs.mobileVerifyComponent.resetModal();
                $(element).modal('show');
                return;
              }

              // eslint-disable-next-line node/no-callback-literal
              callback(true);
            })
            .catch((error) => {
              if (error.response && error.response.status === 429) {
                this.limitMessage = error.response.data.message;
                this.$toasted.show(this.$t('AlertMessages.Bilgileriniz kaydedildi'));
                this.callback = callback;

                if (form.mobile.startsWith('+90') && !form.is_mobile_verified) {
                  this.endWaiting();
                  const element = this.$refs.mobileVerifyComponent.$el;
                  this.$refs.mobileVerifyComponent.resetModal();
                  $(element).modal('show');
                  return;
                }

                // eslint-disable-next-line node/no-callback-literal
                callback(true);
              }
            });
        }
      });
    },
    getDistricts(cityID, callback) {
      $axios.get('district?city_id=' + cityID).then((s) => {
        callback(s.data.data);
      });
    },
    createTestFunctions() {
      this.selectDistrict();
      this.selectCity();
    },
  },
  components: {
    BirthdateInformationModal,
    InputField,
  },
};
</script>
